module.exports = __webpack_public_path__ + "media/images/lamp/green-58612de846a5aa381967136e964836b8.png";